import { render, staticRenderFns } from "./FlexRow.vue?vue&type=template&id=5b643bf0"
import script from "./FlexRow.vue?vue&type=script&lang=js"
export * from "./FlexRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports